import styled from 'styled-components';

export const ErrorMessageWrapper = styled.span`
  width: 100%;
  height: 45px;
  margin-top: 17px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  background-color: rgba(224, 35, 27, 0.1);
  border-radius: 8px;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  margin-left: 5px;
  margin-top: 1px;
`;
